var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.136,
    height: 15.136
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SearchIcon_svg__cls-1{fill:none;stroke:#797979;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SearchIcon_svg__Group_766",
    "data-name": "Group 766",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SearchIcon_svg__Path_160",
    "data-name": "Path 160",
    className: "SearchIcon_svg__cls-1",
    d: "M14.6 9.553A5.052 5.052 0 119.552 4.5 5.052 5.052 0 0114.6 9.553z",
    transform: "translate(-4.5 -4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SearchIcon_svg__Path_161",
    "data-name": "Path 161",
    className: "SearchIcon_svg__cls-1",
    d: "M29.457 29.457l-4.482-4.482",
    transform: "translate(-16.132 -16.132)"
  }))));
};
export default SvgSearchIcon;